import React from 'react';
import {
  ProcessSection,
  SectionHeading,
  ProcessGrid,
  ProcessItem,
  ProcessNumber,
} from './Process.styles';

const Process = () => {
  return (
    <ProcessSection>
      <SectionHeading $center>
        <p className="eyebrowHeader">How It Works</p>

        <h2 style={{ color: 'white' }}>
          From Your Existing PDF to a Digital Form
        </h2>

        <p>
          There is no need to rebuild your safety paperwork from scratch. Start
          with the forms your company already uses.
        </p>
      </SectionHeading>

      <ProcessGrid>
        <ProcessItem>
          <ProcessNumber>01</ProcessNumber>

          <h3>Upload Your PDF</h3>

          <p>
            Send us the existing workplace safety form you want available
            digitally.
          </p>
        </ProcessItem>

        <ProcessItem>
          <ProcessNumber>02</ProcessNumber>

          <h3>We Add the Inputs</h3>

          <p>
            We configure the required fields and inputs so the form can be
            completed online.
          </p>
        </ProcessItem>

        <ProcessItem>
          <ProcessNumber>03</ProcessNumber>

          <h3>Your Team Fills It Out</h3>

          <p>
            Employees can open and complete the form from an iPad or laptop
            instead of relying only on paper copies.
          </p>
        </ProcessItem>

        <ProcessItem>
          <ProcessNumber>04</ProcessNumber>

          <h3>Review the Results</h3>

          <p>
            Completed forms can be viewed, filtered, and queried so important
            information is easier to retrieve.
          </p>
        </ProcessItem>
      </ProcessGrid>
    </ProcessSection>
  );
};

export default Process;
